import React, { useState } from 'react';
import LoadingContext from './loading-context';

interface Props {
    children: React.ReactNode;
}

const LoadingProvider = (props: Props) => {
    const [isLoadingContextList, setIsLoadingContextList] = useState<string[]>([]);

    const setIsLoadingHandler = (isLoading: boolean, context: string) => {
        if (isLoading) {
            setIsLoadingContextList((prevState) => {
                let newState = [...prevState];
                newState.push(context);
                return newState;
            });
        } else {
            setIsLoadingContextList((prevState) => {
                let newState = [...prevState];
                return newState.filter((c) => c !== context);
            });
        }
    };

    const isLoading = isLoadingContextList?.length > 0;

    const loadingContext = {
        isLoading: isLoading,
        setIsLoading: setIsLoadingHandler,
    };

    return (
        <LoadingContext.Provider value={loadingContext}>{props.children}</LoadingContext.Provider>
    );
};

export default LoadingProvider;
